// extracted by mini-css-extract-plugin
export default {"fallback":"AddBorschFlow_fallback__WVEGA","fallbackBtn":"AddBorschFlow_fallbackBtn__SCnr+"};